module.exports = __webpack_public_path__ + "img/myposition_wb_주앙 칸셀루.dce74920.png";